const ELEMENT_SELECTOR = '[data-anchor-tabs]';
const elements = Array.from(document.querySelectorAll(ELEMENT_SELECTOR));

if (elements.length) {
	System.import(
		/* webpackChunkName: "anchor-tabs" */ './anchor-tabs'
	).then((module) => {
		module.default(elements);
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/anchor-tabs/plugin--split.js